unit Places;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmPlacesSetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    frmPlaceSetup: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebDBEdit1: TDBEdit;
    wcPlaces: TXDataWebClient;
    wdsPlaces: TXDataWebDataSet;
    wdsPlacesLoadingNo: TIntegerField;
    wdsPlacesName: TStringField;
    wdsPlacesCityNo: TIntegerField;
    dsPlaces: TDataSource;
    procedure WebButton2Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmPlacesSetup: TfrmPlacesSetup;

implementation

{$R *.dfm}
uses
  stfmssystem.connection, share.common;
procedure TfrmPlacesSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmPlacesSetup.WebFormShow(Sender: TObject);
begin
  wdsPlaces.Open;
  wdsPlaces.Insert;
end;

procedure TfrmPlacesSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  frmPlaceSetup := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  wcPlaces := TXDataWebClient.Create(Self);
  wdsPlaces := TXDataWebDataSet.Create(Self);
  wdsPlacesLoadingNo := TIntegerField.Create(Self);
  wdsPlacesName := TStringField.Create(Self);
  wdsPlacesCityNo := TIntegerField.Create(Self);
  dsPlaces := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  frmPlaceSetup.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  wcPlaces.BeforeLoadDFMValues;
  wdsPlaces.BeforeLoadDFMValues;
  wdsPlacesLoadingNo.BeforeLoadDFMValues;
  wdsPlacesName.BeforeLoadDFMValues;
  wdsPlacesCityNo.BeforeLoadDFMValues;
  dsPlaces.BeforeLoadDFMValues;
  try
    Name := 'frmPlacesSetup';
    Width := 420;
    Height := 220;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 420;
    WebPanel1.Height := 220;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 15;
    WebLabel1.Top := 83;
    WebLabel1.Width := 66;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Place Name:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    frmPlaceSetup.SetParentComponent(WebPanel1);
    frmPlaceSetup.Name := 'frmPlaceSetup';
    frmPlaceSetup.Left := 0;
    frmPlaceSetup.Top := 0;
    frmPlaceSetup.Width := 420;
    frmPlaceSetup.Height := 60;
    frmPlaceSetup.Align := alTop;
    frmPlaceSetup.Caption := 'Place Setup';
    frmPlaceSetup.ChildOrder := 1;
    frmPlaceSetup.Color := clSilver;
    frmPlaceSetup.Font.Charset := DEFAULT_CHARSET;
    frmPlaceSetup.Font.Color := clWindowText;
    frmPlaceSetup.Font.Height := -16;
    frmPlaceSetup.Font.Name := 'Segoe UI';
    frmPlaceSetup.Font.Style := [fsBold];
    frmPlaceSetup.ParentFont := False;
    frmPlaceSetup.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 160;
    WebPanel3.Width := 420;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 15;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 136;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 15;
    WebDBEdit1.Top := 104;
    WebDBEdit1.Width := 298;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'Name';
    WebDBEdit1.DataSource := dsPlaces;
    wcPlaces.SetParentComponent(Self);
    wcPlaces.Name := 'wcPlaces';
    wcPlaces.Connection := dmData.dbConnect;
    wcPlaces.Left := 16;
    wcPlaces.Top := 17;
    wdsPlaces.SetParentComponent(Self);
    wdsPlaces.Name := 'wdsPlaces';
    wdsPlaces.Connection := dmData.dbConnect;
    wdsPlaces.Left := 80;
    wdsPlaces.Top := 17;
    wdsPlacesLoadingNo.SetParentComponent(wdsPlaces);
    wdsPlacesLoadingNo.Name := 'wdsPlacesLoadingNo';
    wdsPlacesLoadingNo.FieldName := 'LoadingNo';
    wdsPlacesName.SetParentComponent(wdsPlaces);
    wdsPlacesName.Name := 'wdsPlacesName';
    wdsPlacesName.FieldName := 'Name';
    wdsPlacesCityNo.SetParentComponent(wdsPlaces);
    wdsPlacesCityNo.Name := 'wdsPlacesCityNo';
    wdsPlacesCityNo.FieldName := 'CityNo';
    dsPlaces.SetParentComponent(Self);
    dsPlaces.Name := 'dsPlaces';
    dsPlaces.DataSet := wdsPlaces;
    dsPlaces.Left := 144;
    dsPlaces.Top := 17;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    frmPlaceSetup.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    wcPlaces.AfterLoadDFMValues;
    wdsPlaces.AfterLoadDFMValues;
    wdsPlacesLoadingNo.AfterLoadDFMValues;
    wdsPlacesName.AfterLoadDFMValues;
    wdsPlacesCityNo.AfterLoadDFMValues;
    dsPlaces.AfterLoadDFMValues;
  end;
end;

end.